// TODO: Add propTypes
/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import { Button, ButtonCondensed, ButtonIcon } from '@companycam/slab-web';

import { getTextFromHTML } from 'components/shared/RichTextEditor/utils';
import { translate } from 'translations/i18n';

const Container = styled.div`
  display: block;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: auto;
`;

const SnippetRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--cc_size_spacing_s);

  padding: 8px 8px 8px 16px;
  cursor: pointer;
  height: 72px;

  border-collapse: collapse;
  border: solid 0.5px;
  border-color: ${(props) => {
    if (props.isDeleting) {
      return 'rgba(228, 57, 53, 0.4)';
    }

    if (props.isSelected) {
      return 'rgba(2, 119, 189, 0.4)';
    }

    return '#D8DCDF';
  }};

  background-color: ${(props) => {
    if (props.isDeleting) {
      return 'rgba(228, 57, 53, 0.1)';
    }

    if (props.isSelected) {
      return 'rgba(2, 119, 189, 0.1)';
    }

    return 'transparent';
  }};

  p {
    color: ${(props) => {
      if (props.isSelected && !props.isDeleting) {
        return 'var(--cc_color_link_primary)';
      } else {
        return 'var(--cc_color_text_default)';
      }
    }};
  }

  :hover {
    ${(props) =>
      props.isSelected
        ? ''
        : `
      background-color: 'var(--cc_color_background_2)';
    `}
  }
`;

const RowLabel = styled.div`
  overflow: hidden;
  width: 95%;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
  margin-right: 6px;
`;

const Content = styled.p`
  font-size: 12px;
  margin: 0;
`;

const NewBanner = styled.span`
  font-size: 9px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: var(--cc_color_utility_success);
  color: white;
  line-height: 14px;
  margin-left: 6px;
`;

const SnippetsList = ({
  snippets,
  selectedSnippet,
  isCreating,
  isDeleting,
  handleClick,
  handleCreateClick,
  handleUseSnippetClick,
}) => {
  const isSelected = (snippetId) => {
    return selectedSnippet ? selectedSnippet.id === snippetId : false;
  };

  const renderSnippetRows = () => {
    let snippetRows = [];
    if (snippets.length === 0) {
      snippetRows.push(
        <SnippetRow key="empty-snippets" empty>
          <Title>{translate('snippets.snippetsList.emptyMsg')}</Title>
          <ButtonCondensed
            color="primary"
            onClick={handleCreateClick}
            disabled={isCreating}
          >
            {translate('snippets.snippetsList.createBtn')}
          </ButtonCondensed>
        </SnippetRow>,
      );
    } else {
      snippetRows = snippets.map((snippet) => (
        <SnippetRow
          key={snippet.id}
          onClick={() => handleClick(snippet)}
          isSelected={isSelected(snippet.id)}
          isDeleting={isSelected(snippet.id) && isDeleting}
        >
          <RowLabel>
            <div style={{ display: 'flex' }}>
              <Title>{snippet.title}</Title>
              {snippets.isNew ? <NewBanner>New</NewBanner> : null}
            </div>

            <Content>{getTextFromHTML(snippet.content)}</Content>
          </RowLabel>
          <Button
            color="primary"
            size="small"
            design="outline"
            onClick={(e) => handleUseSnippetClick(e, snippet.content)}
          >
            {translate('snippets.snippetsList.useBtn')}
          </Button>
          <ButtonIcon
            size="small"
            iconName="pencil"
            design="minimal"
            onClick={() => handleClick(snippet)}
            accessibilityLabel={translate('common.edit')}
          />
        </SnippetRow>
      ));
    }

    if (isCreating) {
      snippetRows.unshift(
        <SnippetRow isSelected key="empty-snippets">
          <RowLabel>
            <div style={{ display: 'flex' }}>
              <Title>
                {translate('snippets.snippetsList.newSnippetTitle')}
              </Title>
            </div>

            <Content>
              {translate('snippets.snippetsList.newSnippetInfo')}
            </Content>
          </RowLabel>
        </SnippetRow>,
      );
    }

    return snippetRows;
  };

  return <Container>{renderSnippetRows()}</Container>;
};

export default SnippetsList;
